module.exports = __webpack_public_path__ + "img/形状 16@2x.51aad437.png";